<template>
    <div class="flex mt-3 text-20 border-t border-tc-gray-4 pt-14px">
        <div class="py-1 px-4 rounded-full cursor-pointer text-tc-blue-1 mr-2 font-main-bold"
             :class="[classBtnDetail]"
             @click="clickTab('detail')">
            {{lbl.detail.detail}}
        </div>
        <div class="py-1 px-4 rounded-full cursor-pointer text-tc-blue-1 font-main-bold"
             :class="[classBtnCondition]"
             @click="clickTab('condition')">
            {{lbl.detail.condition}}
        </div>
    </div>
    <div class="pt-4 text-tc-gray-3 text-20">
        <div v-show="active == 'detail'" v-html="detailText"></div>
        <div v-show="active == 'condition'" v-html="conditionText"></div>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: "DetailAndCondition",
    mixins: [LocaleMixin],
    props: {
        campaign: { type: Object, required: true },
    },
    data: function() {
        return {
            active: 'detail', // detail, condition

            detailText: null,
            conditionText: null,
        };
    },
    computed: {
        classBtnDetail: function() {
            return this.active == 'detail' ? 'bg-tc-gray-5' : 'bg-white';
        },
        classBtnCondition: function() {
            return this.active == 'condition' ? 'bg-tc-gray-5' : 'bg-white';
        },
    },
    created: function() {
        if(this.campaign){
            this.detailText = Util.newLineToBr(this.campaign.detail);
            this.conditionText = Util.newLineToBr(this.campaign.condition);
        }
    },
    methods: {
        clickTab: function(active) {
            this.active = active;
        },
    }
}
</script>
<style lang="scss" scoped>
</style>
